"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const styles_1 = require("./styles");
const Loading = () => (react_1.default.createElement(styles_1.Container, null,
    react_1.default.createElement(polaris_1.Spinner, { accessibilityLabel: 'Loading', size: 'large' })));
exports.Loading = Loading;
